<template>
  <main role="main">
    <div class="page-con">
    <div class="page-list-con no-bn">
        <h2>{{ $t('PRIVACY.TITLE') }}</h2>
        <div class="privacy-con">
            <p>{{ $t('PRIVACY.DESC') }}</p>
            <h3>{{ $t('PRIVACY.CLAUSE_1_TITLE') }}</h3>
            <p>{{ $t('PRIVACY.CLAUSE_1_CONTENT') }}</p>
            <h3>{{ $t('PRIVACY.CLAUSE_2_TITLE') }}</h3>
            <p>{{ $t('PRIVACY.CLAUSE_2_CONTENT_1') }}</p>
            <p>{{ $t('PRIVACY.CLAUSE_2_CONTENT_2') }}</p>
            <p>{{ $t('PRIVACY.CLAUSE_2_CONTENT_3') }}</p>
            <p>{{ $t('PRIVACY.CLAUSE_2_CONTENT_4') }}</p>
            <p>{{ $t('PRIVACY.CLAUSE_2_CONTENT_5') }}</p>
            <h3>{{ $t('PRIVACY.CLAUSE_3_TITLE') }}</h3>
            <p>{{ $t('PRIVACY.CLAUSE_3_CONTENT') }}</p>
            <h3>{{ $t('PRIVACY.CLAUSE_4_TITLE') }}</h3>
            <p>{{ $t('PRIVACY.CLAUSE_4_CONTENT') }}</p>
        </div>
        </div>
    </div>
    <IndexFooter></IndexFooter>
    
</main>
</template>
<script>

export default {
  name: 'Privacy',
  data () {
    return {
        closePrivacy:false
    }
  },
  mounted () {
  
  },
  created(){
  },
  methods: {
      Close(){
          this.closePrivacy = true;
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/Privacy.vue